/**
 * タブレット
 * @constructor
 */
class Tablet {
  constructor() {

  }
  /**
   * タブレット
   */
  init() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('ipad') > -1 || ua.indexOf('Android') > 0
      || ua.indexOf('macintosh') > -1 && 'ontouchend' in document) {
      $('.p-top').addClass('is-active');
    }
  }


 


}

export default Tablet;
